import React from 'react';
import PropTypes from 'prop-types';
import { PERIOD_OPTIONS, RANGE_LABEL_STYLE, getRangeLabel } from './dateRanges';

const buttonStyle = (isActive) => ({
  padding: '5px 14px',
  borderRadius: 4,
  border: `1px solid ${isActive ? '#be210b' : '#3b4a56'}`,
  background: isActive ? '#be210b' : 'transparent',
  color: isActive ? '#fff' : '#8d949b',
  cursor: 'pointer',
  fontWeight: isActive ? 600 : 400,
  fontSize: 13,
  whiteSpace: 'nowrap',
});

/**
 * Red/grey period button bar shared by the KPI widgets, with the selected date range in grey.
 */
const PeriodFilter = ({ title, period, onPeriodChange, rangeLabel }) => (
  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
    {title ? <span style={{ fontWeight: 600, marginRight: 6 }}>{title}</span> : null}
    {PERIOD_OPTIONS.map(({ label, value }) => (
      <button key={value} onClick={() => onPeriodChange(value)} style={buttonStyle(period === value)}>
        {label}
      </button>
    ))}
    <span style={{ ...RANGE_LABEL_STYLE, marginLeft: 'auto' }}>{rangeLabel || getRangeLabel(period)}</span>
  </div>
);

PeriodFilter.propTypes = {
  title: PropTypes.string,
  period: PropTypes.string.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  rangeLabel: PropTypes.string,
};

PeriodFilter.defaultProps = {
  title: '',
  rangeLabel: '',
};

export default PeriodFilter;
